import { render } from "./BrandImageLoader.vue?vue&type=template&id=40a999f3"
import script from "./BrandImageLoader.vue?vue&type=script&lang=js"
export * from "./BrandImageLoader.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__